import React from 'react';
import useGaugeChart from './hooks/useGaugeChart';
import Chart from 'react-apexcharts';

export const Gauge = ({ 
    chartData = [],
    subtitles = [],
    colors,
    title,
    subtitle,
    height = 350,
    series = null
}) => {
    const { chartConfig } = useGaugeChart({
        chartData,
        subtitles,
        colors,
        series
    });

    return (
        <div style={{ 
            textAlign: 'center', 
            width: '100%', 
            fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif' 
        }}>
            <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
                <h2 style={{ 
                    margin: 0, 
                    fontWeight: '400', 
                    fontSize: '24px', 
                    color: '#000' 
                }}>
                    {title}
                </h2>
                {subtitle && (
                    <p style={{ 
                        margin: '4px 0 0 0', 
                        fontSize: '15px', 
                        color: '#333',
                        fontWeight: '400'
                    }}>
                        {subtitle}
                    </p>
                )}
                
            </div>

            <div style={{ pointerEvents: 'none' }}>
                <Chart
                    options={chartConfig.options}
                    series={chartConfig.series}
                    height={height}
                    type="donut"
                />
            </div>
            
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                width: '48%',
                margin: '-200px auto 0 auto', 
                color: '#BDBDBD',
                fontSize: '18px',
                fontWeight: '300'
            }}>
                <span>0%</span>
                <span>100%</span>
            </div>
        </div>
    );
};